import antdSA from "antd/lib/locale-provider/it_IT";

const saLang = {
    messages: {
    //...saMessages
    },
    antd: antdSA,
    locale: 'it',
};
export default saLang;
